/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import * as Data from './transforms/data.js';
import * as Misc from './transforms/misc.js';
import * as Model from './transforms/model.js';
import * as Volume from './transforms/volume.js';
import * as Representation from './transforms/representation.js';
import * as Shape from './transforms/shape.js';
export const StateTransforms = {
    Data,
    Misc,
    Model,
    Volume,
    Representation,
    Shape
};
